/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export enum Envs {
  prod = 'prod',
  stage = 'stage',
  dev = 'dev'
}
export enum Apps {
  careteam = 'careteam',
  patient = 'patient',
  selfreferral = 'self-referral'
}
declare global {
  interface Window {
    env: {
      APP_NAME: Apps;
      ENV_NAME: Envs;
      API_URL: string;
      SENTRY_DSN?: string;
      SENTRY_RELEASE?: string;
      SENTRY_ENVIRONMENT?: string;
      LD_CLIENT_ID?: string;
      GOOGLE_RECAPTCHA_V2_SITE_KEY: string;
      GOOGLE_RECAPTCHA_V3_SITE_KEY: string;
      GOOGLE_MAPS_KEY: string;
      PARDOT_EMAIL_OPT_IN_URL: string;
      PATIENT_APP_URL: string;
    };
    dataLayer: { push: (params: Object) => {} };
  }
}

const {
  APP_NAME,
  ENV_NAME,
  API_URL,
  SENTRY_DSN,
  SENTRY_RELEASE,
  SENTRY_ENVIRONMENT,
  LD_CLIENT_ID,
  GOOGLE_RECAPTCHA_V2_SITE_KEY,
  GOOGLE_RECAPTCHA_V3_SITE_KEY,
  GOOGLE_MAPS_KEY,
  PARDOT_EMAIL_OPT_IN_URL,
  PATIENT_APP_URL
} = window.env;

export {
  APP_NAME,
  ENV_NAME,
  API_URL,
  SENTRY_DSN,
  SENTRY_RELEASE,
  SENTRY_ENVIRONMENT,
  LD_CLIENT_ID,
  GOOGLE_RECAPTCHA_V2_SITE_KEY,
  GOOGLE_RECAPTCHA_V3_SITE_KEY,
  GOOGLE_MAPS_KEY,
  PARDOT_EMAIL_OPT_IN_URL,
  PATIENT_APP_URL
};
